export default __webpack_public_path__ + "static/media/3 Mueble aglomerado alacena.0650677a.jpeg";